@if (customers() && selectedCustomer()) {
  <ui-customer-autocomplete
    (selectChange)="navigateToCustomer($event)"
    [customer]="selectedCustomer()"
    [customers]="customers()!"
    label="Kundennummer"
  ></ui-customer-autocomplete>
}
